import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 120000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const MODELS = [
  { label: "Claude Sonnet 4.6 (Anthropic)", provider: "anthropic", name: "claude-sonnet-4-6" },
  { label: "GPT 5.4 (OpenAI)", provider: "openai", name: "gpt-5.4" },
  { label: "Gemini 3 Flash (Google)", provider: "gemini", name: "gemini-3-flash-preview" },
];

export const DISCIPLINES = ["Engineering", "Medical", "Law", "Sciences", "Arts & Commerce"];

export const GEOGRAPHIES = [
  "Global",
  "United States",
  "Europe",
  "United Kingdom",
  "India",
  "Canada",
  "Australia",
  "Japan",
  "China",
  "Middle East",
  "Africa",
  "South America",
  "Southeast Asia",
];

export const SECTION_KEYS = [
  { key: "outline", label: "Outline" },
  { key: "abstract", label: "Abstract" },
  { key: "background", label: "Background & Literature" },
  { key: "problem_statement", label: "Problem Statement" },
  { key: "objectives", label: "Objectives" },
  { key: "methodology", label: "Methodology" },
  { key: "workplan_timeline", label: "Workplan & Timeline" },
  { key: "expected_outcomes", label: "Expected Outcomes" },
  { key: "impact", label: "Impact" },
  { key: "budget_justification", label: "Budget Justification" },
  { key: "ethics_considerations", label: "Ethics" },
  { key: "dissemination_plan", label: "Dissemination" },
  { key: "sustainability", label: "Sustainability" },
  { key: "references", label: "References" },
];
